<template>
  <footer class="the-footer flex-wrap justify-between" :class="classes">
    <span>{{ $t("CopyrightLeft") }} @ {{ new Date().getFullYear() }}</span>
    <span class="md:flex sm:text-center items-center">
      <span>{{ $t("CopyrightRight") }}</span>
      <feather-icon
        icon="HeartIcon"
        svgClasses="stroke-current text-danger w-6 h-6"
        class="ml-2 heartbeat"
      />
    </span>
  </footer>
</template>

<script>
export default {
  name: "the-footer",
  props: {
    classes: {
      type: String,
    },
  },
};
</script>

<style>
.heartbeat {
  animation: heartbeat 2s infinite;
}
@keyframes heartbeat {
  0% {
    transform: scale(0.75);
  }
  20% {
    transform: scale(1);
  }
  40% {
    transform: scale(0.75);
  }
  60% {
    transform: scale(1);
  }
  80% {
    transform: scale(0.75);
  }
  100% {
    transform: scale(0.75);
  }
}

@media (max-width: 677px) {
  .the-footer {
    font-size: 10px;
    flex-direction: column;
  }

  .heartbeat {
    zoom: 0.6;
    bottom: -10px;
  }
}
</style>
